<div class="pt-0 mt-0">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">إدارة السائقين</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #search (keyup)="($event)"  class="form-control transparent" placeholder="بحث في السائقين" aria-label="Recipient's username" aria-describedby="basic-addon2">

            <i class="fa fa-times-circle pointer left" *ngIf="search.value.length>0" (click)="removeSearch()"></i>
          </div>
        </div>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button" class="btn btn-outline-secondary  dashed-button" (click)="changeEditMode()" data-toggle="modal" data-target="#myModal"  >+ إضافة سائق </button>
      </div>
    </div>
  </div>
<div class="row" >
  <div class="col-md-12">
    <div class="">
      <div class="=">
        <div class="">
          <div class="">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">

                  السائقين تحت الخدمة
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#archive" role="tab" aria-controls="profile" aria-selected="false">أرشيف السائقين</a>
              </li>
            </ul>
          <div class="row" *ngIf="loader">
            <div class="col-md-12">
              <div class="text-center">
                <div class="loader"></div>
              </div>
            </div>
          </div>


            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table no-border">

                      <tbody>
                      <tr *ngFor="let row of drivers|search: 'name' : search.value| paginate: { itemsPerPage: 10, currentPage: p }">
                        <th scope="row"  class="no-border" width="75%">
                          <div class="media align-items-center">
                              <img [src]="row.profile_photo?row.profile_photo:'../../assets/images/profile-square.jpg'" class="avatar rounded-circle mr-3"/>
                              <!--                    <ngx-avatar name="{{row.name}}"></ngx-avatar>-->

                            <div class="d-flex flex-column  ">
                              <div class="text-left">
                                <span class="mb-0 text-sm ">{{row.name}}</span><br>

                              </div>
                              <div class="text-left">
                                <small *ngIf="row.assign_bus.length>0">تم تعينه على الحافلة رقم <span class="bold">
                        {{row.assign_bus}}
                      </span>
                                </small>
                                <small *ngIf="row.assign_bus.length==0">لم يتم تعين اي حافلة</small>

                              </div>
                            </div>
                          </div>
                        </th>
                        <td class="no-border">
                          <div class="d-flex flex-row" >
                            <div class="mr-2  py-2"  >
                              <button class="btn background-blue-g radius-16 w-194" (click)="selectedRow(row)" data-target="#assigneBus" data-toggle="modal" >تعيين السائق لحافلة</button>

                            </div>
                            <div class="mr-2"  >
                              <i data-toggle="modal" data-target="#myModal" (click)="getDriver(row._id)" class="fa pointer border-green green fa-pen circle"></i>

                            </div>
                            <div class=""  >
                              <i  data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(  row)"  class="fa pointer border-red red  fa-trash circle"></i>

                            </div>

                          </div>

                        </td>

                      </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col-md-12">
                        <pagination-controls [previousLabel]="'السابق'" [nextLabel]="'التالي'" (pageChange)="p = $event"></pagination-controls>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="tab-pane fade" id="archive" role="tabpanel" aria-labelledby="profile-tab">

                <div class="row">
                  <div class="col-md-12">
                    <table class="table no-border">

                      <tbody>
                      <tr *ngFor="let row of archiveDrivers|search: 'name' : search.value| paginate: { itemsPerPage: 10, currentPage: p2 }">
                        <th scope="row"  class="no-border" width="75%">
                          <div class="media align-items-center">
                              <img [src]="row.profile_photo?row.profile_photo:'../../assets/images/profile-square.jpg'" class="avatar rounded-circle mr-3"/>
                              <!--                    <ngx-avatar name="{{row.name}}"></ngx-avatar>-->

                            <div class="d-flex flex-column  ">
                              <div class="text-left">
                                <span class="mb-0 text-sm ">{{row.name}}</span><br>

                              </div>
                              <div class="text-left">
                                <small *ngIf="row.assign_bus.length>0">تم تعينه على الحافلة رقم <span class="bold">
                                 {{row.assign_bus}}
                                 </span>
                                </small>
                                <small *ngIf="row.assign_bus.length==0">لم يتم تعين اي حافلة</small>

                              </div>
                            </div>
                          </div>
                        </th>
                        <td class="no-border">
                          <div class="d-flex flex-row" >
                            <div class="mr-2"  >
                              <button class="btn background-blue-g radius-16" (click)="ActiveDriver(row._id)">استعادة</button>
                            </div>

                          </div>

                        </td>

                      </tr>
                      </tbody>
                    </table>
                    <div class="row">
                      <div class="col-md-12">
                        <pagination-controls [previousLabel]="'السابق'" [nextLabel]="'التالي'" (pageChange)="p2 = $event"></pagination-controls>

                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>


      </div>
    </div>



  </div>
</div>
</div>
<!-- Trigger the modal with a button -->

<!-- Modal -->
<div class="modal fade" id="myModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{editMode?"تعديل":"إضافة"}} سائق </h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <p>معلومات السائق</p>
        <form [formGroup]="data"  >
          <div class="row">
            <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12  text-center">
              <img (click)="openFile()"  alt="User Pic" [src]="profileImg"  id="profile-image" class="radius-50 img-circle img-responsive">

              <input (change)="changeImage($event)" accept="image/*" type="file" id="file"  style="display:none"/>
            </div>
          </div>
        <div class="row">
          <div class="col-md-12">
            <label for="exampleInputEmail1">اسم السائق</label>

            <input type="text"  formControlName="name" placeholder="اسم السائق" class="form-control">

          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="exampleInputEmail1">الجنسية</label>

            <input type="text" formControlName="national" placeholder="الجنسية" class="form-control">
          </div>
          <div class="col-md-6">
            <label for="exampleInputEmail1">الرقم الوطني</label>

            <input type="text"   formControlName="ssi"  placeholder="الرقم الوطني" class="form-control">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label for="exampleInputEmail1">العنوان</label>
            <input type="text" formControlName="address" placeholder="العنوان" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label for="exampleInputEmail1">نوع الرخصة</label>
            <select class="form-control" formControlName="license_type" >
              <option value="" disabled selected>نوع الرخصة</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="exampleInputEmail1">رقم الرخصة</label>
            <input type="text"  formControlName="driver_license" placeholder="رقم الرخصة" class="form-control">
          </div>
        </div>
          <div class="row">
          <div class="col-md-6">
            <label for="exampleInputEmail1">الجوال</label>

            <div class="input-group flex-nowrap">
              <input
                type="text" class="form-control" placeholder="الجوال  "
                style="border-top-left-radius: unset !important; border-bottom-left-radius: unset !important;"
                formControlName="phone" aria-label="Username" aria-describedby="addon-wrapping"
              >
              <div class="input-group-prepend">
                <span  style="border-bottom-left-radius: 16px; border-top-left-radius: 16px;direction: ltr;" class="input-group-text" id="addon-wrapping">+962</span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label for="exampleInputEmail1">كلمة المرور</label>
            <input type="text"  formControlName="password" placeholder="كلمة المرور" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>تاريخ الميلاد</label>
            <input type="date"  formControlName="birthday" placeholder="تاريخ الميلاد" class="form-control">
          </div>
          <div class="col-md-6">
            <label>تاريخ انتهاء الرخصة</label>

            <input type="date" formControlName="date_end" class="form-control"/>
          </div>
        </div>

        </form>

        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button"  style="width:280px"  (click)="editMode?edit():add()" [disabled]="!data.valid" data-dismiss="modal"  class="btn radius-16  background-blue-g pr-5 pl-5" >
                {{editMode?"تعديل":"إضافة"}}


              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="assigneBus" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">تعيين سائق للحافلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group mb-3">
              <div class="input-icons">

                <input #search2 type="text" (keyup)="($event)" class="form-control transparent" placeholder="بحث " aria-label="Recipient's username" aria-describedby="basic-addon2">
                <i class="fa fa-search icon">
                </i>
                <i class="fa fa-times-circle pointer left" *ngIf="search2.value.length>0" (click)="removeSearch()"></i>

              </div>
            </div>
          </div>
        </div>
        <table class="table no-border">

          <tbody>
          <tr *ngFor="let row of buses|search: 'name' : search2.value;let i=index">
            <th scope="row"  class="no-border" width="75%">
              <div class="media align-items-center">
                <a href="javascript:void(0)" class="avatar rounded-circle mr-3">
                  <img src="../../assets/images/icons/busFront.svg" width="21" id="" class="  " height="27"/>

                </a>
                <div class="" >
                  <span class="mb-0 text-sm">{{row.bus_identity}}</span>
                </div>
              </div>
            </th>
            <td class="no-border text-right">

              <div class="custom-radios">
                <div>
                  <input (click)="assignToBus(row._id,row.drivers_id?row.drivers_id.includes(selectedDriver._id):false)" type="radio" [checked]="selectedBus.includes(row._id)" id="color-1{{i}}" name="bus"  class="checkbox " value="color-1">
                  <label for="color-1{{i}}">
      <span class="background-blue-g">
        <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg" alt="Checked Icon" />
      </span>
                  </label>
                </div>
              </div>
            </td>

          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal"  style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5"  (click)="saveBus()">حفظ الإضافات</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content modal-raduis    radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف السائق</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
<div class="row">
 <div class=" container text-center">
   <p class="text-black ">
     هل أنت متأكد من رغبتك في حذف السائق( {{selectedDriver['name']}}) ، سيتم حذف جميع البيانات المرتبطة به
   </p>
 </div>
</div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5"  data-dismiss="modal" (click)="removeDriver(selectedDriver['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
